import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const gameVuex = createNamespacedHelpers("game");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "upgrade",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo"]),
    ...gameVuex.mapState(["propertyList", "gameProgress", "gameData"]),
    ...walletVuex.mapState(["isMobile"]),
    propertyListLength() {
      return this.propertyList?.length;
    }
  },
  data() {
    const upgradeList = [];
    return {
      selectTab: null,
      upgradeList,
      popUpgradeResultShow: false,
      selectUpgradeRow: null,
      upgradeResultInfo: {
        level: null,
        isAnim: false,
        anim: {
          step1: false,
          step2: false,
          step3: false
        }
      },
      isUpgradeBotAnim: false,
      popUpgradePrizeShow: false,
      popUpgradePrizeBeforeShow: false,
      selectPopGiftRow: null,
      selectPopGiftRowStep: 0,
      completionReward: null,
      inOnePrizeBeforeStatus: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          await this.getGamePropertyList();
        }
      },
      deep: true,
      immediate: true
    },
    selectTab: {
      handler(newVal) {
        this.propertyList.map(item => {
          item.properties.sort((a, b) => {
            if (a.step >= 10 && b.step >= 10) return 0; // 保持相对顺序
            if (a.step >= 10) return 1; // step >= 10 的排后面
            if (b.step >= 10) return -1;
            // return b.step - a.step; // step < 10 的按降序排列
          });
        });
      }
    },

    "propertyListLength": {
      handler(newLen, oldLen) {
        if (newLen > 0 && newLen != oldLen) {
          this.selectUpgradeRow = this.propertyList[0].properties;
        } else {
          console.log("selectTab", this.selectTab);
          const index = this.propertyList?.findIndex(item => {
            return this.selectTab?.name == item.name;
          });
          if (this.propertyList) {
            this.selectUpgradeRow = this.propertyList[index != -1 ? index : 0].properties;
          }
        }
      },
      deep: true,
      immediate: true
    },
    "gameProgress.currentLevel": {
      async handler(newLevel, oldLevel) {
        if (oldLevel !== undefined && oldLevel !== null && newLevel != oldLevel) {
          this.$httpClear("/game/property/list");
          this.getGamePropertyList();
          this.popUpgradeResultShow = true;
          await new Promise(resolve => setTimeout(resolve, 1000));
          this.upgradeResultInfo.anim.step1 = true;
          await new Promise(resolve => setTimeout(resolve, 300));
          this.upgradeResultInfo.level = this.gameProgress.currentLevel;
          this.upgradeResultInfo.anim.step2 = true;
          await new Promise(resolve => setTimeout(resolve, 300));
          this.setWowAnim();
          this.upgradeResultInfo.anim.step3 = true;
          this.setConfetti();
        }
      },
      deep: true,
      immediate: true
    },
    popUpgradePrizeShow: {
      async handler(bool) {
        if (bool) {
          await this.getSpinsBalance();
        }
      }
    }
  },
  methods: {
    ...gameVuex.mapActions(["upgradeAvatar", "getGamePropertyList"]),
    ...userVuex.mapActions(["getMyInfo", "getSpinsBalance"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    setConfetti() {
      this.confetti({
        particleCount: 15,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        },
        zIndex: 2000,
        colors: ["9cfd09", "3edf46", "0ccf66", "39580e", "a0fe07"]
      });
      this.confetti({
        particleCount: 15,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        },
        zIndex: 2000,
        colors: ["9cfd09", "3edf46", "0ccf66", "39580e", "a0fe07"]
      });
    },
    onTab(item) {
      console.log("onTab", item);
      if (item.properties && item.properties.length > 0) {
        this.selectUpgradeRow = item.properties;
      }
    },
    onUpgradeResultConfirm() {
      this.popUpgradeResultShow = false;
    },
    async onUpgrade(item) {
      if (this.gameData.isQuickUpgradeLoading) {
        this.$toasted.info("upgrading, please wait");
        return;
      }
      if (item.loading) return;
      item.loading = true;
      this.hapticFeedback();
      this.upgradeResultInfo.level = this.gameProgress.currentLevel;
      console.log("this.userInfo.coin", this.userInfo.coin, item.upgrade_cost);
      const res = await this.upgradeAvatar({
        propertyId: item.id
      });
      if (!res) {
        item.loading = false;
        return;
      }
      // await new Promise((reso) => setTimeout(reso, 500));
      await this.upgradeAnim(item);
      this.isUpgradeBotAnim = true;
      setTimeout(() => {
        this.isUpgradeBotAnim = false;
      }, 500);
      this.upgradeInfo(res, item);
    },
    upgradeAnim(item) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          try {
            const mLevelProgressRef = this.$refs.mLevelProgressRef?.$refs.progressRef;
            const endButtonRect = mLevelProgressRef?.getBoundingClientRect();
            const mTabRef = this.$refs.mTabRef?.$refs[`mTab_${item.category_id}`][0];
            const itemRef = this.$refs[`upgradeItem_${item.id}`][0];
            const upgradeBtnRef = itemRef.$refs?.upgradeBtnRef?.getBoundingClientRect();
            const stockButtonRect = this.$refs.stockRef.getBoundingClientRect();
            const end1ButtonRect = mTabRef.getBoundingClientRect();
            const sxRef = this.$refs.sxRef;
            const sxRef1 = this.$refs.sxRef1;
            const sxRef2 = this.$refs.sxRef2;
            sxRef2.style.left = sxRef1.style.left = sxRef.style.left = upgradeBtnRef.left + "px";
            sxRef2.style.top = sxRef1.style.top = sxRef.style.top = upgradeBtnRef.top + upgradeBtnRef.height / 2 + "px";
            sxRef2.style.opacity = sxRef1.style.opacity = sxRef.style.opacity = 1;
            setTimeout(() => {
              try {
                sxRef2.style.transition = sxRef1.style.transition = sxRef.style.transition = "all 0.3s linear";
                sxRef.style.left = endButtonRect.left + endButtonRect.width - 4 + "px";
                sxRef.style.top = endButtonRect.top + endButtonRect.height / 2 - 2 + "px";
                sxRef1.style.left = end1ButtonRect.left + end1ButtonRect.width / 2 + "px";
                sxRef1.style.top = end1ButtonRect.top + end1ButtonRect.height / 2 - 2 + "px";
                sxRef2.style.left = stockButtonRect.left + stockButtonRect.width / 4 + "px";
                sxRef2.style.top = stockButtonRect.top + stockButtonRect.height / 2 - 2 + "px";
                setTimeout(() => {
                  sxRef2.style.opacity = sxRef1.style.opacity = sxRef.style.opacity = 0;
                  sxRef2.style.transition = sxRef1.style.transition = sxRef.style.transition = "";
                  resolve();
                }, 300);
              } catch (err) {
                console.log("errrrrr", err);
                resolve();
              }
            }, 300);
          } catch (err) {
            console.log("errrr12312312321", err);
            resolve();
          }
        });
      });
    },
    checkExactlyStepOneCount(arr, expectedCount) {
      let count = 0;
      for (const item of arr) {
        for (const prop of item.properties) {
          if (prop.step === 1) {
            count++;
          } else if (prop.step !== 0) {
            return false; // 出现非 0 或 1 的 step 值，直接返回 false
          }
        }
      }

      return count === expectedCount;
    },
    //当所有类 第一个元素达到10时 弹出弹窗
    async upgradeEnforcementUpgradePrizeBeforeShow(item) {
      const allStepsAreZero = this.checkExactlyStepOneCount(this.propertyList, 1);
      console.log("allStepsAreZero", allStepsAreZero);
      if (allStepsAreZero) {
        item.isGiftAnim = false;
        this.selectPopGiftRow = item;
        this.inOnePrizeBeforeStatus = item;
        this.popUpgradePrizeBeforeShow = true;
        this.selectPopGiftRowStep = 100;
        await new Promise(resolve => setTimeout(resolve, 400));
        this.selectPopGiftRowStep = item.step / 10 * 100;
      }
    },
    async upgradeInfo(data, item) {
      const categoryInfo = data.categoryInfo[0];
      this.propertyList.map(itm => {
        if (itm.id == categoryInfo.id) {
          for (const key in categoryInfo) {
            if (key !== "properties") {
              this.$set(itm, key, categoryInfo[key]);
            } else {
              itm.properties.map(_it => {
                categoryInfo[key].map(it => {
                  if (_it.id == it.id) {
                    for (const ke in _it) {
                      this.$set(_it, ke, it[ke]);
                      this.$set(_it, "disabled", false); //禁用状态
                      this.$set(_it, "loading", false);
                      this.$set(_it, "isGiftAnim", false);
                      if (_it.id === item.id) {
                        this.$set(_it, "loading", true);
                        if (_it.step === 10) {
                          this.popUpgradePrizeShow = true;
                          this.completionReward = data?.completionReward;
                        }
                        if (_it.step == 1) {
                          this.$set(_it, "isGiftAnim", true); //礼包图标状态
                        }
                      }

                      this.$set(_it, "giftStatus", false); //礼包显示状态
                      if (_it.step >= 1 && _it.step < 10) {
                        this.$set(_it, "giftStatus", true); //当步数大于等于1且小于10时候显示礼包
                      }
                    }
                  }
                });
              });
            }
          }
        }
      });

      if (data.upgradeReward && data.upgradeReward?.length >= 0) {
        this.setStockFloatNumber(data.upgradeReward[0].amount);
      }
      setTimeout(async () => {
        console.log("this.gameProgress.currentLevel333", this.gameProgress.currentLevel, data.levelInfo.currentLevel);
        if (this.gameProgress.currentLevel !== data.levelInfo.currentLevel) {
          await this.getMyInfo();
        }
        this.gameProgress.currentLevel = data.levelInfo.currentLevel;
        this.gameProgress.nextLevel = data.levelInfo.nextLevel === -1 ? -1 : data.levelInfo.nextLevel;
        this.gameProgress.progressInfo = data.progressInfo;
        this.setUserInfo(data.userInfo);
        await this.upgradeEnforcementUpgradePrizeBeforeShow(item);
        item.loading = false;
      }, 500);
      this.propertyList.map(item => {
        item.properties.sort((a, b) => {
          if (a.newStep >= 10 && b.newStep >= 10) return 0; // 保持相对顺序
          if (a.newStep >= 10) return 1; // step >= 10 的排后面
          if (b.newStep >= 10) return -1;
          // return b.step - a.step; // step < 10 的按降序排列
        });
      });
    },

    popUpgradePrizeBeforeConfirm() {
      if (this.inOnePrizeBeforeStatus) {
        this.inOnePrizeBeforeStatus.isGiftAnim = true;
      }
      this.popUpgradePrizeBeforeShow = false;
    },
    popUpgradePrizeConfirm() {
      this.popUpgradePrizeShow = false;
    }
  },
  mounted() {
    this.setWowAnim();
  },
  beforeRouteLeave(to, from, next) {
    if (this.propertyList && this.propertyList.length > 0) {
      this.propertyList.map(item => {
        item.properties.map(itm => {
          _v.$set(itm, "disabled", false); //禁用状态
          _v.$set(itm, "loading", false); //禁用状态
          this.$set(itm, "completion_rate_old", itm.completion_rate);
        });
      });
      console.log("this.propertyList", this.propertyList);
    }
    next();
  }
};